import { httpPut } from "../../fetch/xhr.js";
import { UploadFile } from "../base-file.js";

//#region ../base/upload/methods/direct.ts
var UploadDirect = class extends UploadFile {
	mimeType;
	constructor(params) {
		super(params);
		this.mimeType = params.mimeType;
	}
	getHeaders() {
		const headers = { "Content-Disposition": `attachment; filename=${encodeURIComponent(this.file.name)}` };
		if (this.mimeType) headers["Content-Type"] = this.mimeType;
		return headers;
	}
	handleError(err) {
		if (this.abortController.signal.aborted) {
			this.store.setState((s) => {
				s.state = "aborted";
			});
			this._log("Upload aborted");
			return;
		}
		super.handleUploadFailed();
		throw err;
	}
	async _upload() {
		const state = this.getState();
		const uploadLink = state.asset?.upload_link;
		if (!uploadLink) throw new Error("Asset is missing upload_link");
		if (state.state === "finished" || state.state === "failed" || state.state === "aborted" || state.state === "paused") return;
		try {
			this._log("Starting HTTP PUT");
			await httpPut(uploadLink, this.file, {
				headers: this.getHeaders(),
				signal: this.abortController.signal,
				onProgress: (progress) => {
					this._log("Upload progress", progress);
					this.store.setState((s) => {
						s.progress = progress * .9;
					});
				}
			});
			this.handleUploadFinished();
		} catch (err) {
			this.handleError(err);
		}
	}
};

//#endregion
export { UploadDirect };
//# sourceMappingURL=direct.js.map